/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  UserListsService,
  IUserListsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ISupportedRoleMethods,
  SupportedRoleService,
  BlacklistUserService,
  InviteUserService,
  IBlacklistUserMethods,
  IInviteUserMethods,
  IUserListsDelegateMethods,
  UserListsDelegateService,
  IDelegateWhiteListMethods,
  DelegateWhiteListService,
} from "./components";

export type BlockListUserPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IUserListsMethods &
  ISupportedRoleMethods &
  IUserListsDelegateMethods &
  IDelegateWhiteListMethods &
  IBlacklistUserMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new UserListsService(),
    new InviteUserService(),
    new DelegateWhiteListService(),
    new UserListsDelegateService(),
    new SupportedRoleService(),
    new BlacklistUserService(),
  ];
};

export const getAgent = () => {
  return createAgent<BlockListUserPageAgent>({
    plugins: getPlugins(),
  });
};
